import { render, staticRenderFns } from "./DanhSachNguoiDungKhongThuocVaiTro.vue?vue&type=template&id=4d68f973&scoped=true&"
import script from "./DanhSachNguoiDungKhongThuocVaiTro.vue?vue&type=script&lang=js&"
export * from "./DanhSachNguoiDungKhongThuocVaiTro.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachNguoiDungKhongThuocVaiTro.vue?vue&type=style&index=0&id=4d68f973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68f973",
  null
  
)

export default component.exports